import * as axios from 'axios';


function getAllBillings() { 

    const data = {  }

    const url = `/admin/locations/billings`;
    return axios.get(url, data)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            if (x.status == 'error') {
                return Promise.reject(x);
            }
            return x
        });
}

function getAllBillingsOpen() { 

    const data = {  }

    const url = `/admin/locations/billings-open`;
    return axios.get(url, data)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            if (x.status == 'error') {
                return Promise.reject(x);
            }
            return x
        });
}


export { getAllBillings, getAllBillingsOpen }